import React, { useEffect } from "react";
import Image, { StaticImageData } from "next/image";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { TfiClose } from "react-icons/tfi";
import { Button } from "@/components/common/Button";
import { useIsExpired } from "@/states/user.state";
import useAccountNewShow from "@/hooks/user/account/useAccountNewShow";
import usePlanDetails from "@/hooks/common/usePlanDetails";
import { openChatPopup } from "@/helper/helper";
import { PlanComponentPropsType } from "@/types/all.types";
import style from "@/components/page-modules/dashboard/main/UpgradePopup/UpgradePopup.module.scss";
type LIPropsType = {
  src: string;
  title: string;
  description: string;
};
const ListItem = ({
  src,
  title,
  description
}: LIPropsType) => <li data-sentry-component="ListItem" data-sentry-source-file="index.tsx">
    <Image src={src} alt="list item icon" width={41} height={40} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
    <div>
      <h4>{title}</h4>
      <span>{description}</span>
    </div>
  </li>;
export const UpgradePopup: React.FC<PlanComponentPropsType> = ({
  plan_uuid
}) => {
  const t = useTranslations("AlertsDashboard.UpgradePopup");
  const {
    setParams
  } = useIsExpired();
  const {
    accountNewData
  } = useAccountNewShow();
  const accountInfo = accountNewData?.data;
  const {
    data,
    mutatePlanDetails,
    isLoading
  } = usePlanDetails();
  const handleRequest = () => {
    if (!isLoading) mutatePlanDetails(plan_uuid!);
  };
  useEffect(() => {
    if (plan_uuid) handleRequest();
  }, []);
  function onExpired() {
    setParams({
      isExpired: false
    });
  }
  function onOpenPopup() {
    openChatPopup();
    onExpired();
  }
  const planName = accountInfo?.plan_name === "Free Trial" ? t("trial") : t("planExpired", {
    planName: accountInfo?.plan_name
  });
  return !isLoading ? <div className={style.wrapper} id="upgrade-modal-wrapper" data-sentry-component="UpgradePopup" data-sentry-source-file="index.tsx">
      <div className={style.backdrop} onClick={onExpired}></div>
      <div className={style.box}>
        <button className={style.close_btn} onClick={onExpired}>
          <TfiClose color={"#A1A1A1"} size={16} data-sentry-element="TfiClose" data-sentry-source-file="index.tsx" />
        </button>
        <h3>{planName}</h3>
        <p>{t("upgradeMessage")}</p>
        <ul>
          <div className={style.column}>
            <ListItem src={"/dashboard-assets/modal_expired/1-activate.svg"} title={t("reviveQR")} description={t("activateAllQR")} data-sentry-element="ListItem" data-sentry-source-file="index.tsx" />
            <ListItem src={"/dashboard-assets/modal_expired/3-personalize.svg"} title={t("personalizedPages")} description={t("customizeLandingPages")} data-sentry-element="ListItem" data-sentry-source-file="index.tsx" />
          </div>
          <div className={style.column}>
            <ListItem src={"/dashboard-assets/modal_expired/2-types.svg"} title={t("qrCodeTypes")} description={t("createVarietyQRCodes")} data-sentry-element="ListItem" data-sentry-source-file="index.tsx" />
            <ListItem src={"/dashboard-assets/modal_expired/4-statistics.svg"} title={t("scanMetrics")} description={t("analyzeEffectiveness")} data-sentry-element="ListItem" data-sentry-source-file="index.tsx" />
          </div>
        </ul>
        <div className={style.btn_box}>
          {data?.data.payload.limit_popup_btn_key === "contact" ? <Button className={style.redirect_btn} variant="primary" title={t("contactUs")} onClick={onOpenPopup} id="upgrade-modal-contact-us-btn" /> : <Link href={"/dashboard/pricing"}>
              <Button icon={<Image src={"/dashboard-assets/fxemoji_sparkles.svg"} alt="upgrade now" width={21} height={19} />} className={style.redirect_btn} variant="primary" title={t("upgrade")} onClick={onExpired} id="upgrade-modal-upgrade-btn" />
            </Link>}
        </div>
      </div>
    </div> : <></>;
};